import React from 'react';
import { View } from 'react-native';
import { Device } from 'DeviceUtils';
// eslint-disable-next-line import/no-cycle
import { recordingPages, RecordPage } from 'Pages/RecordPage';
import { getRecordingForItem, getRecordingStatus, RECORDING_STATUS } from 'Utils/itemUtils';
import Icon from 'LocalGluons/components/Icon';

import type { StyleMap, PlayerData } from 'Types';
import playerModalStyles from '../PlayerModal/style';
import { useRecordings } from '../../../RecordingsContext/RecordingsContext';
import defaultStyles from './RecordingOptionsModal.jss';
import { useAppErrorHandler } from '../../../../../runtime/App/AppErrorHandlerContext/AppErrorHandlerContext';

const getPageByStatus = (item) => {
    const { data } = getRecordingForItem(item);
    const isSimple = data?.type === 'SIMPLE';
    switch (getRecordingStatus(item)) {
        // This is just stupid..
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        case RECORDING_STATUS.PLANNED:
            return isSimple
                ? recordingPages.cancelRecordingsSimple
                : recordingPages.cancelRecordings;
        // This is just stupid..
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        case RECORDING_STATUS.ARCHIVED:
            return isSimple
                ? recordingPages.deleteRecordingSimple
                : recordingPages.deleteRecordings;
        // This is just stupid..
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        case RECORDING_STATUS.DONE:
            return isSimple
                ? recordingPages.deleteRecordingSimple
                : recordingPages.deleteRecordings;
        default:
            return item.isSeries()
                ? recordingPages.setRecordings
                : recordingPages.setRecordingsSimple;
    }
};

interface RecordingOptionsModalProps {
    style?: StyleMap;
    liveItem: PlayerData['item'];
    onClose: () => void;
    refreshDetailItem: (isLiveRecording?: boolean) => void;
    setModalContent: (modal: any) => void;
}

const RecordingOptionsModal = ({
    style,
    liveItem,
    onClose,
    refreshDetailItem,
    setModalContent
}: RecordingOptionsModalProps) => {
    const { setError } = useAppErrorHandler();
    const { updateRecordings } = useRecordings();

    const onRecordStateChanged = () => {
        refreshDetailItem(true);
        updateRecordings();
    };

    return (
        <View style={[defaultStyles.container, style]}>
            <RecordPage
                orientation={Device.isPhone ? 'landscape' : 'portrait'}
                width={Device.isPhone ? undefined : 400}
                withModalHeader={Device.isTabletOrWeb}
                style={defaultStyles.recordPage}
                item={liveItem}
                page={getPageByStatus(liveItem)}
                onClose={onClose}
                onRecordStateChanged={onRecordStateChanged}
                setError={setError}
                setModalContent={setModalContent}
            />
            {Device.isPhone && (
                <Icon name="close" style={playerModalStyles.iconClose} onPress={onClose} />
            )}
        </View>
    );
};

export default RecordingOptionsModal;
